const dayjs = require('dayjs')
const localeData = require('dayjs/plugin/localeData')
dayjs.extend(localeData)

const MONTHS= dayjs.months()

module.exports = MONTHS